import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/api';
import { environment } from 'src/environments/environment';
import { ClientMigrationComponent } from '../project/client-migration/client-migration.component';

@Component({
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
})
export class IntroComponent implements OnInit {
  loginLink = `${environment.api}/oauth2/authorization/samsung?redirect_uri=${window.location.href}`;
  logged = false;
  gnbElement: HTMLElement;

  @ViewChild('loginRequired', { static: true })
  loginRequired: TemplateRef<any>;

  constructor(
    protected authService: AuthService,
    protected router: Router,
    @Inject(DOCUMENT) private document: Document,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.gnbElement = this.document.getElementById('gnb');
    this.gnbElement.style.display = 'none';
    this.authService.userInfo$.subscribe((userInfo) => {
      if (userInfo && userInfo.login_id) {
        this.logged = true;
        this.gnbElement.style.display = 'block';
      } else {
        this.gnbElement.style.display = 'none';
        this.logged = false;
      }
    });
  }

  changeStatusMenu() {
    this.gnbElement.style.display = 'block';
  }

  handlePopup() {
    if (this.logged) {
      this.router.navigate(['/project/create']);
    } else {
      this.dialog.open(this.loginRequired, {
        panelClass: 'loginRequiredModal',
        id: 'loginRequired',
        autoFocus: false,
        restoreFocus: false,
      });
    }
  }

  handleMigrateClient() {
    this.dialog.open(ClientMigrationComponent, {
      panelClass: 'client-migration',
      width: '580px',
      id: 'migrateClientModal',
      autoFocus: false,
      restoreFocus: false,
    });
  }

  handleLogin() {
    this.authService.login();
  }
}
